import { useMelioIntl } from '@melio/ar-domain';
import { IconKey, SelectionCard } from '@melio/penny';
import { FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

export const useGetFundingSourceCardProps = (type: FundingSource['type']) => {
  const { formatMessage } = useMelioIntl();
  const iconMap: Record<FundingSource['type'], IconKey> = {
    'bank-account': 'bank',
    card: 'credit-card',
  };

  const labelMap: Record<FundingSource['type'], string> = {
    'bank-account': formatMessage('ar.guestPayment.activities.paymentMethods.bank.label'),
    card: formatMessage('ar.guestPayment.activities.paymentMethods.card.label'),
  };

  const descriptionMap: Record<FundingSource['type'], string> = {
    'bank-account': formatMessage('ar.guestPayment.activities.paymentMethods.bank.description.text'),
    card: formatMessage('ar.guestPayment.activities.paymentMethods.card.description.text'),
  };

  const icon = iconMap[type];
  const label = labelMap[type];
  const description = descriptionMap[type];
  return { icon, label, description };
};

export type FundingSourceListProps = {
  type: FundingSource['type'];
  onSelect: (fundingSourceType: FundingSource['type']) => void;
  badge?: string;
};

export const AddFundingSourceCard = forwardRef<FundingSourceListProps>(({ onSelect, type, badge, ...props }, ref) => {
  const { description, icon, label } = useGetFundingSourceCardProps(type);
  return (
    <SelectionCard
      data-component="AddFundingSourceCard"
      icon={icon}
      mainLabelProps={{
        label,
        badgeProps: badge
          ? {
              label: badge,
              status: 'brand',
            }
          : undefined,
      }}
      descriptionProps={{ label: description }}
      onClick={() => onSelect(type)}
      {...props}
      ref={ref}
    />
  );
});
AddFundingSourceCard.displayName = 'AddFundingSourceCard';
